import React from "react";
import "./AboutPage.css";
import AboutImage from "./aboutImage.png"


const AboutPage = () => {
  return (
    <section className="About_pg_section">

      <div className="About_pg_row">
        <div className="About_pg_col About_pg_col_text">
          
          <h2 className="About_pg_heading">
            Built for how people{" "}
            <span className="About_pg_heading_accent">actually learn</span>
          </h2>

          <p className="About_pg_paragraph">
            Our Learning Management System brings courses, learners, and
            instructors together in one simple platform. From onboarding new
            employees to running full certification programs, everything you
            need to create, deliver, and track learning is in one place.
          </p>

          <p className="About_pg_paragraph">
            Instructors can build courses with videos, quizzes, and assignments
            in minutes. Learners get a clear path to follow, with progress
            tracking that keeps them motivated. Admins get real-time reports on
            completion rates, scores, and engagement, so nothing falls through
            the cracks.
          </p>

          <ul className="About_pg_list">
            <li className="About_pg_list_item">
              <span className="About_pg_list_icon About_pg_list_icon_teal">
                &#10003;
              </span>
              Course creation with videos, quizzes, and assignments
            </li>
            <li className="About_pg_list_item">
              <span className="About_pg_list_icon About_pg_list_icon_gold">
                &#10003;
              </span>
              Progress tracking and completion certificates
            </li>
            <li className="About_pg_list_item">
              <span className="About_pg_list_icon About_pg_list_icon_blue">
                &#10003;
              </span>
              Real-time analytics and reporting for admins
            </li>
            <li className="About_pg_list_item">
              <span className="About_pg_list_icon About_pg_list_icon_teal">
                &#10003;
              </span>
              Works on desktop, tablet, and mobile
            </li>
          </ul>

          <div className="About_pg_stats_row">
            <div className="About_pg_stat_chip About_pg_stat_chip_teal">
              <span className="About_pg_stat_num">500+</span>
              <span className="About_pg_stat_label">Courses</span>
            </div>
            <div className="About_pg_stat_chip About_pg_stat_chip_gold">
              <span className="About_pg_stat_num">10k+</span>
              <span className="About_pg_stat_label">Learners</span>
            </div>
            <div className="About_pg_stat_chip About_pg_stat_chip_blue">
              <span className="About_pg_stat_num">98%</span>
              <span className="About_pg_stat_label">Completion</span>
            </div>
          </div>
        </div>

        <div className="About_pg_col About_pg_col_image">
          <div className="About_pg_image_frame">
            <img
              src={AboutImage}
              alt="Learning management system dashboard"
              className="About_pg_image"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutPage;
